<template>
  <div v-if="note">
    <v-alert border="left" color="orange" dense outlined text>
      <span class="revision-request"
        ><span class="revision-request-note">Requested Revision: </span
        >{{ note }}</span
      >
    </v-alert>
    <!--v-divider></v-divider-->
    <!--This exists in some contexts so we might want to conditionally add it-->
  </div>
</template>

<script>
export default {
  name: "RevisionRequestNote",
  props: {
    note: {
      type: String,
      default: null
    }
  }
};
</script>

<style lang="sass" scoped>
.revision-request
  font-style: italic
  font-size: 16px

.revision-request-note
  font-weight: bold
</style>
